import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useClerk } from "@clerk/react";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { useMember } from "@/components/MemberProvider";
import { errMsg } from "@/lib/api";

export const TermsGate = () => {
  const { me, acceptTerms } = useMember();
  const { signOut } = useClerk();
  const { pathname } = useLocation();
  const [age, setAge] = useState(false);
  const [terms, setTerms] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!me || me.terms_accepted || pathname === "/terms") return null;

  const submit = async () => {
    setBusy(true);
    try { await acceptTerms(); toast.success("Welcome to The Weekend Edge"); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-[90] bg-[#0B101D]/95 backdrop-blur-xl grid place-items-center p-4" data-testid="terms-gate">
      <div className="w-full max-w-md rounded-3xl bg-[#131C31] border border-blue-500/30 p-8 rise">
        <h1 className="font-display text-2xl font-black uppercase tracking-tight mb-2">One last step</h1>
        <p className="text-sm text-slate-400 mb-6">Before you use your member account, please confirm the following.</p>
        <label className="flex gap-3 items-start mb-4 cursor-pointer">
          <Checkbox data-testid="terms-gate-age" checked={age} onCheckedChange={(v) => setAge(!!v)} className="mt-0.5" />
          <span className="text-sm">I am 18 years of age or older.</span>
        </label>
        <label className="flex gap-3 items-start mb-6 cursor-pointer">
          <Checkbox data-testid="terms-gate-accept" checked={terms} onCheckedChange={(v) => setTerms(!!v)} className="mt-0.5" />
          <span className="text-sm">I have read and accept the <Link to="/terms" target="_blank" className="text-blue-400 underline" data-testid="terms-gate-link">Terms & Conditions</Link>, and understand tips are opinions, not guarantees.</span>
        </label>
        <button data-testid="terms-gate-submit" onClick={submit} disabled={!age || !terms || busy}
          className="w-full py-3 rounded-full bg-blue-600 hover:bg-blue-500 font-semibold disabled:opacity-40 transition-colors">{busy ? "Saving…" : "Continue"}</button>
        <button data-testid="terms-gate-signout" onClick={() => signOut()} className="w-full mt-3 text-xs text-slate-500 hover:text-slate-300">Sign out instead</button>
      </div>
    </div>
  );
};
